import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SERVICES } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const Card = ({ s }) => (
  <Link to={`/${s.slug}`} data-testid={`service-card-${s.slug}`} className={`group relative flex min-h-[380px] flex-col justify-end overflow-hidden border border-white/10 bg-panel ${s.span}`}>
    <div className="absolute inset-0">
      <img src={s.image} alt={s.title} className="h-full w-full object-cover opacity-30 transition-all duration-700 group-hover:scale-105 group-hover:opacity-45" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-transparent" />
    </div>
    <div className="absolute right-0 top-0 h-px w-0 bg-brand-cyan transition-all duration-500 group-hover:w-full" />
    <div className="relative p-8 md:p-10">
      <div className="mb-4 flex items-center gap-3">
        <span className="font-mono text-xs text-brand-cyan">{s.index}</span>
        <span className="h-px w-8 bg-white/20" />
      </div>
      <h3 className="font-display text-2xl font-bold leading-tight md:text-3xl">{s.title}</h3>
      <p className="mt-3 font-body text-sm text-slatex-300">{s.short}</p>
      <div className="mt-6 flex flex-wrap gap-x-5 gap-y-1.5">
        {s.points.slice(0, 5).map((p) => (
          <span key={p} className="font-mono text-[11px] uppercase tracking-wide text-slatex-500">{p}</span>
        ))}
      </div>
      <div className="mt-6 flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-white/70 transition-colors group-hover:text-brand-cyan">
        Explore <ArrowUpRight size={14} weight="bold" className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>
    </div>
  </Link>
);

export const ServicesBento = () => (
  <section data-testid="services-bento" className="relative border-t border-white/10 py-24 md:py-32">
    <div className="mx-auto max-w-[1440px] px-6 md:px-12">
      <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <div className="mb-4 flex items-center gap-3">
            <span className="h-px w-10 bg-brand-cyan" />
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cyan">Core Services</span>
          </div>
          <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-[0.98] tracking-tight md:text-5xl">
            Precision troubleshooting. Clean installations.
          </h2>
        </div>
        <p className="max-w-sm font-body text-sm text-slatex-300">
          From no-heat diagnostics to crane-coordinated rooftop change-outs — every job is approached like engineering, not guesswork.
        </p>
      </Reveal>

      <motion.div initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
        variants={{ show: { transition: { staggerChildren: 0.1 } } }}
        className="grid grid-cols-1 gap-4 lg:grid-cols-12">
        {SERVICES.map((s) => (
          <motion.div key={s.slug} className={s.span}
            variants={{ hidden: { opacity: 0, y: 40 }, show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } } }}>
            <Card s={s} />
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default ServicesBento;
